<template>
	<div>
		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<button class="btn btn-light" style="position: absolute; right: 0.5em; top: 0.5em;" @click.prevent="refreshApiKey"><i class="fas fa-sync-alt"></i> Refresh</button>
				<h4 class="my-0 font-weight-normal">API Key Settings</h4>
			</div>
			<div class="card-body">
				<form autocomplete="off">

					<div>
						<strong class="text-danger">UPCOMING:</strong> All other API Key settings/configs, for example:
						<ol>
							<li>Data mask query filters for each collection access instance in an API key.</li>
							<li>Augmentation Behaviour:
								<ol>
									<li>Standard - augmentations are shown by default, but can be bypassed with "unaugmented" option flag parameter.</li>
									<li>Force augmentations (cannot disable augmentations; they act like source data)</li>
									<li>Hide augmentations (cannot access my augmentations at all)</li>
								</ol>
							</li>
							
						</ol>
						<hr>
					</div>

					<div class="form-group">
						<label for="apiKeySettings_id">Title</label>
						<input v-model="apiKeySettings.title" type="text" class="form-control" id="apiKeySettings_title" aria-describedby="apiKeySettings_titleHelp" placeholder="Enter title">
						<small id="apiKeySettings_titleHelp" class="form-text text-muted">Title (name) for this API Key (e.g. "Access for Joe's Online Store")</small>
					</div>
					<div class="form-group">
						<label for="apiKeySettings_desc">Description</label>
						<textarea v-model="apiKeySettings.description" type="text" class="form-control" id="apiKeySettings_desc" aria-describedby="apiKeySettings_descHelp" placeholder="Enter description" rows="2"></textarea>
						<small id="apiKeySettings_descHelp" class="form-text text-muted">Descriptive details (e.g. "This is a testing API key")</small>
					</div>
					<div class="form-check mb-3">
						<input v-model="apiKeySettings.disabled" type="checkbox" class="form-check-input" id="apiKeySettings_disabled">
						<label class="form-check-label" for="apiKeySettings_disabled">Disabled <small class="text-muted">(this API key will not be active)</small></label>
					</div>
					
					<div class="form-group">
						<label for="apiKeySettings_starts">Active Starting Date</label>
						<input v-model="newActiveStarts" type="datetime-local" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}" class="form-control" id="apiKeySettings_starts" aria-describedby="apiKeySettings_starts" placeholder="Enter starting date">
						<small id="apiKeySettings_startsHelp" class="form-text text-muted">The date and time at which this API key will start to be active.</small>
					</div>

					<div class="form-group">
						<label for="apiKeySettings_expires">Expiry Date</label>
						<input v-model="newActiveExpires" type="datetime-local" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}" class="form-control" id="apiKeySettings_expires" aria-describedby="apiKeySettings_expires" placeholder="Enter expiry date">
						<small id="apiKeySettings_expiresHelp" class="form-text text-muted">The date and time at which this API key expires, and becomes inactive.</small>
					</div>
					
					<div class="form-group">
						<label for="apiKeySettings_projPerm">Project-Wide Permission Role</label>
						<div class="form-check">
							<input v-model="newProjectRole" type="radio" name="projRole" value="" class="form-check-input" id="apiKeySettings_projPerm_none">
							<label class="form-check-label text-muted" for="apiKeySettings_projPerm_none"><em>None</em> <small class="text-muted">(no project-wide access, usually used with collection-sepcific permissions below)</small></label>
						</div>
						<div class="form-check">
							<input v-model="newProjectRole" type="radio" name="projRole" value="read" class="form-check-input" id="apiKeySettings_projPerm_read">
							<label class="form-check-label" for="apiKeySettings_projPerm_read">Read <small class="text-muted">(complete read access for all collections, including readonly for project settings)</small></label>
						</div>
						<div class="form-check">
							<input v-model="newProjectRole" type="radio" name="projRole" value="write" class="form-check-input" id="apiKeySettings_projPerm_write">
							<label class="form-check-label" for="apiKeySettings_projPerm_write">Write <small class="text-muted">(complete read/write for all collections, including readonly for project settings)</small></label>
						</div>
						<div class="form-check">
							<input v-model="newProjectRole" type="radio" name="projRole" value="admin" class="form-check-input" id="apiKeySettings_projPerm_admin">
							<label class="form-check-label" for="apiKeySettings_projPerm_admin"><span style="color: red;">Admin</span> <small class="text-muted">(complete access to collections and editing of project settings, other than ownership)</small></label>
						</div>
					</div>
					
					<div class="form-group">
						<label>Collection-Specific Permissions</label>
						<table class="table table-bordered table-hover table-responsive">
							<thead>
								<tr>
									<th scope="col" style="width: 100%;">Collection Name <em class="text-muted">(ID)</em></th>
									<th scope="col" class="text-center" style="min-width: 80px;">Read</th>
									<th scope="col" class="text-center" style="min-width: 80px;">List</th>
									<th scope="col" class="text-center" style="min-width: 80px;">Create</th>
									<th scope="col" class="text-center" style="min-width: 80px;">Update</th>
									<th scope="col" class="text-center table-danger" style="min-width: 80px;">Delete</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="collection in collectionList" :key="collection.$id">
									<th scope="row" class="font-weight-normal">{{collection.title}} <em class="text-muted">({{collection.$id.split(':')[1]}})</em></th>
									<td class="text-center"><input v-model="newCollectionPermissions[collection.$id+'.r']" type="checkbox"></td>
									<td class="text-center"><input v-model="newCollectionPermissions[collection.$id+'.l']" type="checkbox"></td>
									<td class="text-center"><input v-model="newCollectionPermissions[collection.$id+'.c']" type="checkbox"></td>
									<td class="text-center"><input v-model="newCollectionPermissions[collection.$id+'.u']" type="checkbox"></td>
									<td class="text-center table-danger"><input v-model="newCollectionPermissions[collection.$id+'.d']" type="checkbox"></td>
								</tr>
							</tbody>
						</table>
					</div>
					
					<button class="btn btn-success mt-4" @click.prevent="saveApiKeySettings"><i class="fas fa-save"></i> Save Settings</button>
					<button class="btn btn-secondary mt-4" @click.prevent="resetApiKey"><i class="fas fa-sync-alt"></i> Reset Editor</button>
					<button class="btn btn-danger float-right mt-4" @click.prevent="deleteThisApiKey"><i class="fas fa-times"></i> Delete API Key</button>
				</form>
			</div>
		</div>

		<div class="card shadow-sm">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">API Key Settings (JSON)</h4>
			</div>
			<div class="card-body">
				<div id="editor"></div>
				<button class="btn btn-success mt-4" @click.prevent="saveEditorApiKey"><i class="fas fa-save"></i> Save Settings</button>
				<button class="btn btn-secondary mt-4" @click.prevent="resetApiKey"><i class="fas fa-sync-alt"></i> Reset Editor</button>
			</div>
		</div>
	</div>
</template>

<script>
import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { toJsonDate } from '../util';
import _ from 'lodash';

const DEFAULTS_SETTINGS = {
	permissions : { project : { }, collections : { } }
}

export default {
	name: "api-key",
	props: [ 'nodeId', 'projectId', 'theKey' ],
	data() {
		return {
			apiKeySettings: { },
			newProjectRole: "",
			newActiveStarts: "",
			newActiveExpires: "",
			newCollectionPermissions: { },
		};
	},
	watch:
	{
		newCollectionPermissions:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				let dataPermissions = { };
				for( let p in newValue )
				{
					let permission = newValue[p];

					let [ cid, type ] = p.split( '.' );
					let [ project, cname ] = cid.split( ':' );
					if( !dataPermissions[cname] )
						dataPermissions[cname] = { };
					
					if( permission === true )
						dataPermissions[cname][type] = permission;
				}
				if( !this.apiKeySettings.permissions )
					this.apiKeySettings.permissions = { };
				console.log( JSON.stringify( dataPermissions, null, 2 ) );
				this.$set( this.apiKeySettings.permissions, 'collections', dataPermissions );
			}
		},
		newProjectRole: function( newValue, oldValue )
		{
			if( !this.apiKeySettings.permissions )
				this.apiKeySettings.permissions = { };
			if( newValue === 'read' || newValue === 'write' || newValue === 'admin' )
				this.apiKeySettings.permissions.project = { [newValue] : true };
			else
				this.apiKeySettings.permissions.project = { };
		},
		newActiveStarts: function( newValue, oldValue )
		{
			try {
				this.$set( this.apiKeySettings, 'starts', toJsonDate( this.newActiveStarts ) );
			} catch( err ) { this.$delete( this.apiKeySettings, 'starts' ); }
		},
		newActiveExpires: function( newValue, oldValue )
		{
			try {
				this.$set( this.apiKeySettings, 'expires', toJsonDate( this.newActiveExpires ) );
			} catch( err ) { this.$delete( this.apiKeySettings, 'expires' ); }
		},
		apiKeySettings:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				try {
					let projPerm = this.apiKeySettings.permissions.project;
					for( let role in projPerm )
						if( projPerm[role] !== true )
							delete projPerm[role];
				} catch( err ) { }
				this.setEditorApiKey( );
			}
		}
	},
	computed:
	{
		currentSessionAccount: function( )
		{
			try {
				let sessionGuid = this.activeSession( this.nodeId );
				let [ sNode, sKey ] = sessionGuid.split( "/" );
				let session = this.session( sessionGuid );
				let account = this.account( sNode, session.account );
				if( account )
					return account;
			} catch( err ) { }
			return { };	// No session.
		},
		...mapGetters( "accounts", {
			account: "account",
		}),
		...mapGetters( "authentication", {
			activeSession: "activeSession",
			session: "session"
		}),
		...mapGetters( "collections", {
			collections: "collections",
		}),
		collectionList( ) {
			return this.collections( this.nodeId, this.projectId );
		}
	},
	methods:
	{
		async refreshApiKey( )
		{
			// TODO: Start Loading
			await this.readApiKey( { nodeId : this.nodeId, projectId : this.projectId, key : this.theKey, nocache : true } );
			this.resetApiKey( );
			// TODO: End Loading
		},
		resetApiKey( )
		{
			this.apiKeySettings = _.defaultsDeep( _.cloneDeep( this.getApiKey( ) ), DEFAULTS_SETTINGS );

			this.newActiveStarts = this.apiKeySettings.starts || "";
			this.newActiveExpires = this.apiKeySettings.expires || "";
			
			let perm = this.apiKeySettings.permissions.project || { };
			this.newProjectRole = ( perm.admin ? "admin" : ( perm.write ? "write" : ( perm.read ? "read" : "" ) ) );
			
			this.newCollectionPermissions = { };
			for( let c in this.apiKeySettings.permissions.collections )
			{
				let perms = this.apiKeySettings.permissions.collections[c];
				for( let type in perms )
				{
					if( c.indexOf( ':' ) < 1 )
						c = this.projectId +":"+ c;
					if( perms[type] === true )
						this.newCollectionPermissions[c+'.'+type] = true;
				}
			}
		},
		async deleteThisApiKey( )
		{
			if( !confirm( "Are you sure you want to delete this apiKey?" ) )
				return;
			try {
				let result = await this.deleteApiKey( { nodeId : this.nodeId, projectId : this.projectId, key : this.theKey } );
				if( !result )
					console.warn( "[ApiKey] API Key was not found at deletion! Redirecting to ApiKeys listing anyway." );
				this.$router.push( { name : 'apikeys', params : { nodeId : this.nodeId, projectId : this.projectId } } );
			} catch( err ) {
				console.error( err );
				alert( "API Key could not be deleted!\n"+ err.message );
			}
		},
		getApiKey( )
		{
			return this.$store.getters['apiKeys/apiKey']( this.nodeId, this.projectId, this.theKey );
		},
		setEditorApiKey( apiKey )
		{
			apiKey = apiKey || this.apiKeySettings;
			if( apiKey && this.editor )
			{
				let editorApiKey = _.omit( apiKey, [ '$created', '$modified', '$version', '$node' ] );
				this.editor.setValue( JSON.stringify( editorApiKey, null, 2 ), -1 );
			}
		},
		async saveApiKeySettings( )
		{
			let apiKey = this.apiKeySettings;

			let id = this.getApiKey( ).$id;

			try {
				let updates = _.omit( apiKey, [ '$created', '$modified', '$version', '$node' ] );
				let result = await this.updateApiKey( { nodeId : this.nodeId, projectId : this.projectId, key : this.theKey, updates : updates } );
				if( null === result )
					throw new Error( "This apiKey is no longer found in the repository!" );
				
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "API Key save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				this.$router.push( { name : 'apikeys', params : { nodeId : this.nodeId, projectId : this.projectId } } );
			}
		},
		async saveEditorApiKey( )
		{
			// TODO: Set loading overlay
			let apiKey;

			try {
				apiKey = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Could not save the object:\n"+ err.message );
				console.error( err );
				return;
			}

			try {
				let result = await this.updateApiKey( { nodeId : this.nodeId, projectId : this.projectId, key : this.theKey, updates : apiKey } );
				if( null === result )
					throw new Error( "This apiKey is no longer found in the repository!" );
				
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "API Key save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				this.$router.push( { name : 'apikeys', params : { nodeId : this.nodeId, projectId : this.projectId } } );
			}
		},
		...mapActions({
			readApiKey: "apiKeys/read",
			updateApiKey: "apiKeys/update",
			deleteApiKey: "apiKeys/delete",
			listCollections: "collections/list",
		}),
	},
	async mounted( )
	{
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			await this.listCollections( { nodeId : this.nodeId, projectId : this.projectId } );
			await this.refreshApiKey( );
		} catch( err ) { throw err; }
	}
};
</script>
<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/ApiKey.vue